// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-with-icon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-icon {
  font-size: 16px;
  cursor: pointer;
  margin-left: auto;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/search/dqoi-search/invoice-search-results/invoice-search-results.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AACF","sourcesContent":[".header-with-icon {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.close-icon {\n  font-size: 16px;\n  cursor: pointer;\n  margin-left: auto;\n  z-index: 100;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
